<!-- TagsInput.vue 通用输入框 -->
<template>
  <div class="muli-tags" @click='focus' id="muli-tags">
    <div class="textTitle" v-if="title">{{title}}</div>
    <div class="textbg" v-if="tags.length<1 && !textbgShow ">{{message}}</div>
    <button class='btn' 
        v-for='(tag, index) in tags' 
        :key='index' 
        :title="tag"
        >{{tag}} <span @click='delTag(index)' class="close-icon"><span class="close-font"></span></span>
    </button>
    <input type="text"
        ref='input'
        @keyup.enter="add"
        @keydown.space="split" 
        @keydown.delete="del"
        @keydown.188='split'
        v-model='current' 
        @blur="endTextbg"
        @focus="showTextbg"
        autocomplete="off" 
        v-clearEmoji
        >
        <!-- :placeholder="(tags.length<1 && textbgShow)?message:''"  -->
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    props: {
        value: Array,
        required: true,
        title: "",
        message: "",
        type: "",
        default: () => []
    },
    data() {
        return {
            textbgShow: false,
            current: '',
        }
    },
    computed: {
        tags () {
            return this.value?this.value.slice():[]
        }
    },
    watch: {
        tags(val){
        
        }
    },
    methods: {
        focus () {
            this.$refs.input.focus();
        },
        split (e) {
            e.preventDefault();
            this.add(e);
        },
        add (e) {
            const val = commonUtils.matchExtension(e.target.value.trim());
            if (!val) return;
            if (this.tags.indexOf(val) > -1) return;
            this.tags.push(val);
            this.$emit('input', this.tags);
            this.current = '';
        },
        del (e) {
            if (!e.target.value.length) {
                this.tags.pop();
                this.$emit('input', this.tags);
            }
        },
        delTag (index) {
            this.tags.splice(index, 1);
            this.$emit('input', this.tags);
        },
        endTextbg(e) {
            //移出焦点触发add
            if(e.target.value) {
                this.add(e);
            }
            this.textbgShow = false;
        },
        showTextbg () {
            this.textbgShow = true;
        }
    },
    filters: {
    }
}
</script>

<style lang='less' scoped>
.muli-tags{
    //padding: 0px 0.1rem;
    display: block;
    border: 0.01rem solid #e0eaf9;
    overflow: auto;
    padding-bottom: 15px;/*no*/
    input {
        width: auto;
        height: 32px;/*no*/
        border: 0px;/*no*/
        margin-top: 15px;/*no*/
        margin-left: 15px;/*no*/
        padding-left: 0.1rem;
        color:black;
        background: transparent;
        position:relative;
        &:focus {
            border : 0px;
        }
    }
    .btn{
        color:#5562B4;
        height: 32px;/*no*/
        margin: 15px 0 0 15px;/*no*/
        padding: 8px 10px 8px 15px !important;/*no*/
        background: rgba(0, 106, 254, 0.05);
        border-radius: 20px;/*no*/
        //box-shadow:  0 0 4px;
        border: 1px solid rgba(0, 96, 229, 0.08);/*no*/
        gap: 10px;/*no*/
        position: relative;
        &:hover {
            border: 1px solid #C1CBE3;
            background: rgba(0, 96, 229, 0.08);
            // .close-icon {
            //     background: #5562B4;
            //     .close-font {
            //         color: #FFFFFF;
            //     }
            // }
        }
        &.muli-tag-error {
            background : #FFF3F3 !important;
            border-color : #FC7E7E !important;
            color : #FC7E7E !important;
        }
        
        .close-icon {
            display: inline-block;
            padding: 4px;/*no*/
            border-radius: 16px;/*no*/
            margin-left:10px;/*no*/
            vertical-align:middle;
            margin-bottom: 1px;/*no*/
            &:hover {
                background: #5562B4;
                .close-font {
                    color: #FFFFFF;
                }
            }
            .close-font {
                display: block;
                background: none;
                border: none;
                cursor: pointer;
                font-size: 8px; /*no*/
                color: #5562B4;
                position: relative;
                width: 8px;/*no*/
                height: 8px;/*no*/
            }
            .close-font::before, .close-font::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 1px; /*no*/
                background-color: currentColor;
            }
            .close-font::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }
            .close-font::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    .textbg {
        position: absolute;
        left: 15px;/*no*/
        margin-top: 15px;/*no*/
        width: auto;
        height: 32px;/*no*/
        z-index: -1;
        color: #cccccf;
        line-height: 32px;/*no*/
    }

}

#muli-tags::-webkit-scrollbar{
  width: 0.08rem;
  height: 0px;
  background-color: #fff;
}

#muli-tags::-webkit-scrollbar-thumb{
  height: 0.01rem;
  border-radius: 5px;
  background-color: #becae4;
}

#muli-tags .textTitle{
  float: left;
  min-width: 40px;/*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/common/input/tag_input_common.vue